/* Pack 3x2 (ver snippets/alma-pack-3x2.liquid). */
(function () {
  var el = document.getElementById('alma-pack-3x2');
  if (!el || window.__almaPack) return;
  window.__almaPack = true;
  var data = JSON.parse(el.textContent);

  function convert(fd) {
    var items = {}, rest = [];
    fd.forEach(function (value, key) {
      var m = key.match(/^items\[(\d+)\]\[(\w+)\](.*)$/);
      if (m) {
        (items[m[1]] = items[m[1]] || { extra: [] });
        if (m[2] === 'id' || m[2] === 'quantity') items[m[1]][m[2]] = value;
        else items[m[1]].extra.push([m[2] + m[3], value]);
      } else rest.push([key, value]);
    });
    var list = Object.keys(items).sort(function (a, b) { return a - b; }).map(function (k) { return items[k]; });
    // Formulario simple (sin tarjeta de cantidades): id + quantity.
    if (!list.length && fd.get('id')) {
      list = [{ id: fd.get('id'), quantity: fd.get('quantity') || 1, extra: [] }];
      rest = rest.filter(function (e) { return e[0] !== 'id' && e[0] !== 'quantity'; });
    }
    var designs = [], others = [];
    list.forEach(function (it) {
      var name = data.kit[it.id];
      if (name) for (var i = 0; i < parseInt(it.quantity || 1, 10); i++) designs.push(name);
      else others.push(it);
    });
    if (designs.length !== 3) return null;
    var packId = data.pack[designs.join('|')];
    return (packId ? Promise.resolve(packId) : buscar(designs)).then(function (id) {
      return id ? armar(id, rest, others) : null;
    });
  }

  // Busca la variante del pack con esos 3 diseños (para combinaciones fuera de las primeras 250)
  function buscar(designs) {
    if (!data.values || data.values.length < 3) return Promise.resolve(null);
    var ids = designs.map(function (d, i) { return data.values[i][d]; });
    if (ids.some(function (x) { return !x; })) return Promise.resolve(null);
    return originalFetch.call(window, data.url + '?option_values=' + ids.join(',') + '&section_id=pack-lookup')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/data-id="(\d+)"[^>]*data-available="true"[^>]*data-title="([^"]*)"/);
        if (!m) return null;
        var t = document.createElement('textarea'); t.innerHTML = m[2];
        return t.value === designs.join(' / ') ? m[1] : null;
      })
      .catch(function () { return null; });
  }

  function armar(packId, rest, others) {

    var out = new FormData();
    rest.forEach(function (e) { out.append(e[0], e[1]); });
    var lines = [{ id: packId, quantity: 1, extra: [] }].concat(others);
    // Pincel de regalo con el 3x2 (si no viene ya en el pedido)
    if (data.gift && !others.some(function (o) { return String(o.id) === String(data.gift); })) {
      lines.push({ id: data.gift, quantity: 1, extra: [] });
    }
    lines.forEach(function (it, i) {
      out.append('items[' + i + '][id]', it.id);
      out.append('items[' + i + '][quantity]', it.quantity || 1);
      it.extra.forEach(function (e) { out.append('items[' + i + '][' + e[0], e[1]); });
    });
    return out;
  }

  var originalFetch = window.fetch;
  window.fetch = function (url, opts) {
    try {
      var path = typeof url === 'string' ? url : (url && url.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(path) && opts && opts.body instanceof FormData) {
        var self = this;
        var pending = convert(opts.body);
        if (pending) {
          return pending.then(function (body) {
            return originalFetch.call(self, url, body ? Object.assign({}, opts, { body: body }) : opts);
          }, function () { return originalFetch.call(self, url, opts); });
        }
      }
    } catch (e) { /* si algo falla, se agrega tal cual */ }
    return originalFetch.call(this, url, opts);
  };
})();

/* Tarjeta de cantidades: por defecto cada kit trae un diseño DISTINTO (#1 = el elegido arriba,
   #2 y #3 = los siguientes disponibles), por si la clienta no los cambia. Si ella los cambia a mano, se respeta. */
(function () {
  // Mientras cambiamos los selectores, la galería NO salta a la foto del diseño ni la página se mueve:
  // la primera foto del producto se queda siempre como la primera.
  function sinMoverGaleria(fn) {
    var galerias = Array.prototype.slice.call(document.querySelectorAll('media-gallery'));
    var originales = galerias.map(function (g) { return g.setActiveMedia; });
    galerias.forEach(function (g) { g.setActiveMedia = function () {}; });
    var x = window.scrollX, y = window.scrollY;
    fn();
    setTimeout(function () {
      galerias.forEach(function (g, i) { g.setActiveMedia = originales[i]; });
      if (Math.abs(window.scrollY - y) > 2) window.scrollTo(x, y);
    }, 700);
  }
  function diversificar() { sinMoverGaleria(diversificarAhora); }
  function diversificarAhora() {
    document.querySelectorAll('quantity-breaks .quantity-break').forEach(function (card) {
      var sels = Array.prototype.slice.call(card.querySelectorAll('select.quantity-break__variant-select'));
      if (sels.length < 2) return;
      var libres = Array.prototype.slice.call(sels[0].options)
        .filter(function (o) { return !o.disabled && !o.classList.contains('unavailable'); })
        .map(function (o) { return o.value; });
      if (libres.length < 2) return;
      var primero = libres.indexOf(sels[0].value) > -1 ? sels[0].value : libres[0];
      var orden = [primero].concat(libres.filter(function (v) { return v !== primero; }));
      sels.forEach(function (s, i) {
        var v = orden[i % orden.length];
        if (s.value !== v) {
          s.value = v;
          s.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
    // El tema toma como elegida la última tarjeta cuyos selectores cambiaron: devolvemos el foco a la tarjeta marcada.
    var marcada = document.querySelector('quantity-breaks input[name="quantity"]:checked');
    var tarjeta = marcada && document.querySelector('quantity-breaks .quantity-break[data-quantity="' + marcada.value + '"]');
    var sel = tarjeta && tarjeta.querySelector('select.quantity-break__variant-select');
    if (sel) sel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  window.almaDiversificar = diversificar;
  function alCargar() { setTimeout(diversificar, 300); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alCargar); else alCargar();
  // Cuando eligen un diseño en los chips de arriba (o desde "Conoce nuestros mundos"), el tema iguala los 3 selectores:
  // dejamos el elegido en el #1 y volvemos a variar el resto.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(diversificar, 120);
  });
})();

/* Pestaña "Pincel de precisión de regalo" al pie de la tarjeta "3 kits" */
(function () {
  var el = document.getElementById('alma-pack-3x2');
  if (!el) return;
  var data = JSON.parse(el.textContent);
  if (!data.gift) return;
  function poner() {
    document.querySelectorAll('quantity-breaks .quantity-break[data-quantity="3"]').forEach(function (card) {
      if (card.querySelector('.alma-regalo')) return;
      var tag = document.createElement('div');
      tag.className = 'alma-regalo';
      tag.innerHTML = (data.giftImg ? '<img src="' + data.giftImg + '" alt="Pincel de precisión de regalo" width="56" height="56" loading="lazy">' : '') +
        '<div class="alma-regalo__txt"><strong>🎁 PINCEL DE PRECISIÓN DE REGALO</strong>' +
        '<span>' + (data.giftPrice ? 'Valor <s>' + data.giftPrice + '</s> · ' : '') + 'Gratis con tu 3x2</span></div>';
      card.appendChild(tag);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poner); else poner();
  document.addEventListener('change', function () { setTimeout(poner, 150); });
})();

/* Botón fijo "Agregar al carro": muestra el precio de la tarjeta elegida (1, 2 o 3 kits), no el de un kit suelto */
(function () {
  function precioBoton() {
    var marcada = document.querySelector('quantity-breaks input[name="quantity"]:checked');
    var tarjeta = marcada && document.querySelector('quantity-breaks .quantity-break[data-quantity="' + marcada.value + '"]');
    var precio = tarjeta && tarjeta.querySelector('.quantity-break__price');
    if (!precio) return;
    document.querySelectorAll('[id^="sticky-atc-price-"]').forEach(function (el) {
      el.textContent = precio.textContent.trim() + ' •';
    });
  }
  function luego() { setTimeout(precioBoton, 200); }
  document.addEventListener('change', luego);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('quantity-breaks')) luego();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(precioBoton, 600); });
  else setTimeout(precioBoton, 600);
})();
